//__made by Mateusz Janeczek__

import React from 'react';
import s from './InputWithValidator.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

class InputWithValidator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      value: ''
    }
  }

  onChange = (e) => {
    this.setState({value: e.target.value}, () => {
      const validateState = this.props.validateMe(this.state.value, this.props.shouldValid);
      this.setState({ isValid: validateState });
    })
  }

  render () {
    return (
      <div className={this.state.isValid ? "form-group" : "form-group has-warning has-feedback"}>
        <label htmlFor="nawisko">{this.props.inputName}</label>
        <input 
          onChange={this.onChange} 
          type={this.props.type} 
          value={this.state.value} 
          name="nawisko" id="nazwisko" 
          className={"form-control"} 
          placeholder={this.props.placeHolder} 
        />
        {!this.state.isValid ? <span className="glyphicon glyphicon-warning-sign form-control-feedback"></span> : null}
        {!this.state.isValid ? <label style={{color: "orange"}}>{this.props.errorMessage}</label> : null}                  
      </div>  
      )
  }
}

export default withStyles(s)(InputWithValidator);


// WEBPACK FOOTER //
// src/components/InputWithValidator/InputWithValidator.js